import { RicosNodeStyle } from './node-style.js';
import { RicosTextStyle } from './text-style.js';
import { Decorations } from '../decorations/decorations.js';
import 'lodash';
import '../utils-398956f3.js';
import 'ricos-schema';
import '../decorations/bold-decoration.js';
import '../decorations/empty-decoration.js';
import '../decorations/color-decoration.js';
import '../decorations/font-size-decoration.js';
import '../decorations/italic-decoration.js';

class RicosTextNodeStyle {
  constructor(style) {
    this.getTextNodeStyle = () => this.style;
    this.overrideWith = (style) => {
      const decorations = Decorations.of(this.style.decorations).overrideWith(style.decorations).toDecorationArray();
      const nodeStyle = RicosNodeStyle.of(this.style.nodeStyle).overrideWith(style.nodeStyle || {}).getNodeStyle();
      const lineHeight = RicosTextStyle.of({ lineHeight: this.style.lineHeight }).overrideWith({
        lineHeight: style.lineHeight
      }).getTextStyle().lineHeight;
      const textNodeStyle = JSON.parse(JSON.stringify({ decorations, nodeStyle, lineHeight }));
      return new RicosTextNodeStyle(textNodeStyle);
    };
    this.style = style;
  }
}

export { RicosTextNodeStyle as default };
//# sourceMappingURL=text-node-style.js.map
